import { Controller } from "@hotwired/stimulus"

// Open/closed state for the floating development panel. Remembered per browser,
// because it follows you across every page load and reopening it each time gets
// old within a minute.
export default class extends Controller {
    static targets = ["panel"]

    static values = { key: { type: String, default: "dev-toolbar-open" } }

    connect() {
        if (this.remembered) this.show()
    }

    toggle() {
        this.panelTarget.hidden ? this.show() : this.hide()
    }

    show() {
        this.panelTarget.hidden = false
        this.element.classList.add("dev-toolbar--open")
        this.remember(true)
    }

    hide() {
        this.panelTarget.hidden = true
        this.element.classList.remove("dev-toolbar--open")
        this.remember(false)
    }

    get remembered() {
        try {
            return localStorage.getItem(this.keyValue) === "1"
        } catch {
            return false
        }
    }

    remember(open) {
        try {
            localStorage.setItem(this.keyValue, open ? "1" : "0")
        } catch {
            // Private mode. Losing the preference is not worth an error.
        }
    }
}
